import { useState } from "react";
import { TextoRico, ESTILO_ENLACES } from "./ContenidoMarkdown";

export interface FAQItem {
  q: string;
  /** Texto plano (también el que va a los datos estructurados). */
  a: string;
  /** HTML saneado de la respuesta cuando viene de contenido editable (specs/138). */
  aHtml?: string | null;
}

export function FAQAccordion({
  items,
  title = "Preguntas frecuentes",
  eyebrow = "· Preguntas frecuentes",
  surface = true,
}: {
  items: FAQItem[];
  title?: string;
  eyebrow?: string;
  surface?: boolean;
}) {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <section id="faq" className={`${surface ? "bg-surface" : ""} py-20 md:py-28`}>
      <div className="mx-auto max-w-4xl px-5 md:px-8">
        <div className="text-center">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">
            {eyebrow}
          </span>
          <h2 className="mt-3 font-display text-3xl font-bold leading-[1.1] tracking-tight text-secondary md:text-4xl">
            {title}
          </h2>
        </div>

        <div className="mt-10 divide-y divide-border rounded-lg border border-border bg-background shadow-soft">
          {items.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q}>
                <button
                  type="button"
                  id={`faq-question-${i}`}
                  onClick={() => setOpen(isOpen ? null : i)}
                  className={`flex w-full cursor-pointer items-center justify-between gap-4 px-6 py-5 text-left transition-colors hover:bg-surface/60 ${
                    isOpen ? "border-b-2 border-primary" : "border-b-0"
                  }`}
                  aria-expanded={isOpen}
                  aria-controls={`faq-panel-${i}`}
                >
                  <span
                    className={`font-display text-base md:text-lg ${isOpen ? "font-semibold text-primary-text" : "font-medium text-foreground"}`}
                  >
                    {f.q}
                  </span>
                  <span
                    className={`grid h-8 w-8 shrink-0 place-items-center rounded-lg bg-surface text-secondary transition-transform ${
                      isOpen ? "rotate-45 bg-primary text-primary-foreground" : ""
                    }`}
                  >
                    +
                  </span>
                </button>
                {isOpen && (
                  <div
                    id={`faq-panel-${i}`}
                    role="region"
                    aria-labelledby={`faq-question-${i}`}
                    className={`animate-rise px-6 pb-6 pt-0 text-sm leading-relaxed text-muted-foreground ${ESTILO_ENLACES}`}
                  >
                    <TextoRico t={{ html: f.aHtml ?? null, texto: f.a }} />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export { faqJsonLd } from "@/lib/jsonld-servicios";
